import goods from "@/service/goods";
import order from "@/service/order";
import merchant from "@/service/merchant";
import member from "@/service/member";

export default {
  merchant,
  order,
  goods,
  member,
}
